/*
 * fn: getCardFrontId
 *
 * Gets just the front card's card ID
 *
 */
import { getCardRef } from './getCardRef'

export const getCardFrontId = (name: string) => getCardRef({ name: name.split(' // ')[0] ?? name }).cardId
